module.exports = __webpack_public_path__ + "static/media/step1mobile.cf84d5ab.png";